// extracted by mini-css-extract-plugin
export default {"listsPromotion":"ListPromotions_listsPromotion__swMpO","listsPromotionButton":"ListPromotions_listsPromotionButton__Lguto"};